// extracted by mini-css-extract-plugin
module.exports = {"image":"Estilos_image__2DTv_","carousel":"Estilos_carousel__1GCul","card":"Estilos_card__3_Fjc","imgBody":"Estilos_imgBody__y116o"};